if (!customElements.get('azantic-product-card-hover')) {
  class AzanticProductCardHover extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initImageHover();
    }

    initImageHover() {
      const productCards = document.querySelectorAll('.azantic-product-card');

      productCards.forEach((productCard) => {
        productCard.addEventListener('mouseenter', () => {
          productCard.setAttribute('data-state', 'open');
        });

        productCard.addEventListener('mouseleave', () => {
          productCard.setAttribute('data-state', 'close');
        });
      });
    }
  }

  customElements.define('azantic-product-card-hover', AzanticProductCardHover);
}
